export default __webpack_public_path__ + "static/media/System fields icon.7ead65a1.svg";